import React, {useState, createContext, useEffect} from 'react';
import theme from './theme';

import Connexion from './pages/Login';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import './App.css';

import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Statistiques from './pages/Statistiques';
import Billets from './pages/Billets';
import Commandes from './pages/Commandes';
import Events from './pages/Event';
import Users from './pages/Users';
import Scanner from './pages/Scanner';
import AdmPayments from './pages/AdmPayments';
import Guichet from './pages/Guichet';
import Promo from './pages/Promo';

export const Context = createContext()

function App() {
  const [isConnected, setIsConnected] = useState(!!sessionStorage.getItem('token'));

  return (
    <Context.Provider value={{ isConnected, setIsConnected}}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {isConnected ? <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/commandes" element={ <Commandes/>} />
          <Route path="/billets" element={ <Billets/>} />
          <Route path="/statistiques" element={ <Statistiques/>} />
          <Route path="/event" element={ <Events/>} />
          <Route path="/users" element={ <Users/>} />
          <Route path="/scanner" element={<Scanner />} />
          <Route path="/paiements" element={<AdmPayments />} />
          <Route path="/guichet" element={<Guichet />} />
          <Route path="/promotions" element={<Promo />} />
          <Route path="*" element={<Home />} />
        </Routes> :
        <Routes>
          <Route path="/" element={<Connexion />} />
          <Route path="/connexion" element={<Connexion />} />
          <Route path="*" element={<Connexion />} />
        </Routes>}
      </Router>
    </ThemeProvider>
    </Context.Provider>
  );
}

export default App;